import React from 'react';

const LaundryPlaceholder = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={108} height={76} fill="none" {...props}>
    <path fill="#F5F5F5" d="m53 40.5 3-1.5h5.5l.5.5v1l.5 2.5H61v-2.5h-4l-1.5.5-1.5 1.5.5.5h8v.5l-6 1H50l3-4Z" />
    <path fill="#F3F3F3" d="M10 49h26v24H10z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 74.32h106"
    />
    <path
      fill="#F6F9FA"
      d="M100.166 13.846h3.341a.988.988 0 0 0 .884-.546l2.273-4.546a.988.988 0 0 0-.394-1.3l-6.104-3.487M84.36 13.846h-3.341a.988.988 0 0 1-.884-.546l-2.273-4.546a.988.988 0 0 1 .394-1.3l6.104-3.487m11.855 0a3.952 3.952 0 0 1-7.904 0H84.36v20.746a.988.988 0 0 0 .988.988h13.83a.988.988 0 0 0 .988-.988V3.967h-3.951Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M100.166 13.846h3.341a.988.988 0 0 0 .884-.546l2.273-4.546a.988.988 0 0 0-.394-1.3l-6.104-3.487m0 0v20.746a.988.988 0 0 1-.988.988h-13.83a.988.988 0 0 1-.988-.988V3.967m15.806 0h-3.951a3.952 3.952 0 0 1-7.904 0H84.36m0 9.879h-3.341a.988.988 0 0 1-.884-.546l-2.273-4.546a.988.988 0 0 1 .394-1.3l6.104-3.487"
    />
    <path
      fill="#959595"
      d="M31.895 40H10.557A3.522 3.522 0 0 0 7 43.556v27.03a3.522 3.522 0 0 0 3.556 3.556h21.34a3.522 3.522 0 0 0 3.556-3.556v-27.03A3.522 3.522 0 0 0 31.895 40Zm-21.338 1.423h21.338c1.138 0 2.134.995 2.134 2.133v4.98H8.423v-4.98c0-1.138.995-2.133 2.133-2.133Zm21.338 31.296H10.557c-1.139 0-2.134-.995-2.134-2.133V49.957h25.606v20.627c0 1.139-.996 2.134-2.134 2.134Z"
    />
    <path
      fill="#959595"
      d="M21.226 52.803c-4.695 0-8.536 3.841-8.536 8.536 0 4.694 3.841 8.535 8.536 8.535 4.694 0 8.535-3.84 8.535-8.535s-3.84-8.536-8.535-8.536Zm0 10.67c-1.138 0-2.134-.996-2.134-2.134s.996-2.134 2.134-2.134 2.134.996 2.134 2.134-.996 2.134-2.134 2.134Zm-.711-9.105v3.556c-1.565.285-2.846 1.708-2.846 3.415 0 .569.143.995.285 1.565l-2.845 2.133c-.57-1.138-.996-2.418-.996-3.698 0-3.699 2.845-6.686 6.402-6.97Zm.71 14.084c-2.133 0-3.982-.854-5.263-2.276l2.845-2.134c.57.569 1.423.853 2.419.853.853 0 1.707-.284 2.418-.853l2.845 2.133c-1.28 1.423-3.13 2.277-5.263 2.277Zm6.118-3.415-2.845-2.134c.284-.426.284-.995.284-1.564 0-1.707-1.28-3.13-2.845-3.414v-3.557c3.556.285 6.402 3.272 6.402 6.97 0 1.281-.427 2.561-.996 3.7ZM30.473 44.268a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM27.627 44.268a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM24.782 44.268a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM24.782 47.113a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM27.627 47.113a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM30.473 47.113a.711.711 0 1 0 0-1.423.711.711 0 0 0 0 1.423ZM10.227 46.48c0 .211.159.317.318.317h3.184c.16 0 .319-.106.319-.316l.796-2.108c.08-.21.08-.316 0-.527-.08-.21-.16-.21-.319-.21H9.75c-.16 0-.239.105-.318.21-.08.106-.08.316 0 .527l.796 2.108Zm3.661-1.79-.398 1.053h-2.706l-.398-1.054h3.502Z"
    />
    <path
      fill="#F6F9FA"
      d="M81.989 13.879h3.34a.988.988 0 0 0 .884-.546l2.273-4.546a.987.987 0 0 0-.393-1.3L81.989 4m-15.807 9.879-3.682.96c-.184 0-.844.096-1 0-.156-.097-.418-.836-.5-1l-1.315-5.052a.988.988 0 0 1 .393-1.3L66.182 4m11.855 0a3.951 3.951 0 1 1-7.903 0h-3.952v20.746a.988.988 0 0 0 .988.988H81a.988.988 0 0 0 .989-.988V4h-3.952Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M81.989 13.879h3.34a.988.988 0 0 0 .884-.546l2.273-4.546a.987.987 0 0 0-.393-1.3L81.989 4m0 0v20.746a.988.988 0 0 1-.988.988H67.17a.988.988 0 0 1-.989-.988V4M81.99 4h-3.952a3.951 3.951 0 1 1-7.903 0h-3.952m0 9.879-3.682.96c-.184 0-.844.096-1 0-.156-.097-.418-.836-.5-1l-1.315-5.052a.988.988 0 0 1 .393-1.3L66.182 4"
    />
    <path
      fill="#F3F3F3"
      d="m35.377 73.142-2.108-8.732h-.707a1.062 1.062 0 0 1 0-2.123h21.586a1.062 1.062 0 1 1 0 2.123h-.708l-1.793 8.668a2 2 0 0 1-1.959 1.595H37.322a2 2 0 0 1-1.944-1.531Z"
    />
    <path
      stroke="#959595"
      d="m33.27 64.41 2.107 8.732a2 2 0 0 0 1.944 1.53h12.367a2 2 0 0 0 1.959-1.594l1.793-8.668m0 0H32.562a1.062 1.062 0 0 1 0-2.123h21.586a1.062 1.062 0 1 1 0 2.123h-.708Z"
    />
    <rect
      width={1.523}
      height={6.478}
      x={37.138}
      y={66.315}
      fill="#F3F3F3"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.762}
      transform="rotate(-6 37.138 66.315)"
    />
    <path
      stroke="#959595"
      strokeWidth={0.5}
      d="m37.41 68.488 1.408-.148M37.558 69.895l1.408-.147M37.706 71.303l1.408-.148"
    />
    <rect
      width={1.523}
      height={6.478}
      x={40.843}
      y={66.262}
      fill="#F3F3F3"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.762}
      transform="rotate(-3 40.843 66.262)"
    />
    <path
      stroke="#959595"
      strokeWidth={0.5}
      d="m41.001 68.446 1.413-.074M41.075 69.859l1.413-.074M41.149 71.273l1.414-.074"
    />
    <rect
      width={1.523}
      height={6.478}
      x={44.72}
      y={66.182}
      fill="#F3F3F3"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.762}
      transform="rotate(3 44.72 66.182)"
    />
    <path
      stroke="#959595"
      strokeWidth={0.5}
      d="m44.649 68.371 1.414.074M44.575 69.784l1.414.074M44.501 71.198l1.414.074"
    />
    <rect
      width={1.523}
      height={6.478}
      x={48.431}
      y={66.156}
      fill="#F3F3F3"
      stroke="#959595"
      strokeWidth={0.6}
      rx={0.762}
      transform="rotate(6 48.431 66.156)"
    />
    <path
      stroke="#959595"
      strokeWidth={0.5}
      d="m48.246 68.338 1.408.148M48.098 69.745l1.408.148M47.95 71.153l1.408.148"
    />
    <circle cx={19.976} cy={45.266} r={1.676} fill="#fff" stroke="#959595" strokeWidth={0.6} />
    <path stroke="#959595" strokeLinecap="round" strokeWidth={0.6} d="M20.039 42.8v1.771" />
    <path
      fill="#959595"
      d="M62.384 40.266c-.15-.773-.693-1.43-1.418-1.606l.067-.634a.226.226 0 0 0-.05-.177.212.212 0 0 0-.163-.077h-.002c.418-.547 1.303-1.554 2.153-1.554.119 0 .215-.1.215-.222a.219.219 0 0 0-.215-.222c-1.234 0-2.406 1.583-2.693 1.998h-.103a.21.21 0 0 0-.134.049l-1.017.84H57.81c-1.345 0-3.87 1.136-3.87 1.136L53.5 40l-.5.5-.567.437c-1.517 1.393-2.47 3.051-2.814 3.708-.117.227-.177.36-.177.36a.227.227 0 0 0 .043.25l.33.34-.378.975a.228.228 0 0 0 .022.207c.04.06.107.097.178.097H61.25a.213.213 0 0 0 .178-.097.228.228 0 0 0 .022-.207l-.357-.92 1.974-1.02a.224.224 0 0 0 .115-.241l-.798-4.123Zm-9.594.937a9.448 9.448 0 0 1 1.05-.825c1.252-.845 2.587-1.274 3.97-1.274h2.675a1.518 1.518 0 0 1 1.477 1.25l.552 2.85c-2.92 1.215-8.419 1.272-11.399 1.303-.349.003-.665.007-.933.011.437-.776 1.316-2.15 2.608-3.315Zm-2.835 5.227.258-.666h10.462l.258.666H49.955Z"
    />
    <path
      fill="#959595"
      d="M54.407 43.064h6.372a.66.66 0 0 0 .477-.197.534.534 0 0 0 .147-.46l-.294-1.708c-.047-.281-.31-.485-.626-.485h-2.705c-.412 0-.81.07-1.182.208-.821.295-2.27.925-2.758 1.824a.517.517 0 0 0 .034.55.647.647 0 0 0 .535.268Zm-.19-.652c.441-.813 1.92-1.416 2.537-1.638.323-.12.668-.18 1.024-.18h2.705c.105 0 .193.068.21.162l.293 1.709a.176.176 0 0 1-.05.154.215.215 0 0 1-.157.065H54.407a.212.212 0 0 1-.178-.09.171.171 0 0 1-.012-.182Zm-2.153 1.354c.017 0 .035 0 .052-.003l1.16-.13c.115-.014.197-.109.182-.213-.014-.104-.121-.177-.236-.165l-1.158.13.714-.77a.177.177 0 0 0-.027-.267.227.227 0 0 0-.297.024l-.714.77a.35.35 0 0 0-.046.426.43.43 0 0 0 .37.198Zm1.185-1.652a.223.223 0 0 0 .149-.056l.211-.19a.177.177 0 0 0 0-.268.228.228 0 0 0-.298 0l-.211.19a.177.177 0 0 0 0 .268.223.223 0 0 0 .149.056Z"
    />
    <path
      fill="#7D7D7D"
      stroke="#959595"
      d="M43.729 47.834a.832.832 0 0 1 .744-.46h56.453a.832.832 0 1 1 0 1.664H44.473a.832.832 0 0 1-.744-1.204Z"
    />
    <rect
      width={51.06}
      height={0.888}
      x={47.202}
      y={49.982}
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={0.888}
      rx={0.444}
    />
    <path stroke="#959595" d="M60.966 52.424v-1.11h2.886v1.11h-2.886ZM84.72 52.424v-1.11h-2.886v1.11h2.886Z" />
    <path
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={0.6}
      d="M80.28 74.624 61.854 52.646h1.11l18.204 21.312-.888.666Z"
    />
    <path
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={0.6}
      d="m65.406 74.624 18.426-21.978h-1.11L64.518 73.958l.888.666Z"
    />
    <path fill="#EFEFEF" d="M58.746 35.774h4.884l-2.442 2.886h-2.22l-.222-2.886Z" />
    <rect width={11.4} height={3.4} x={88.3} y={43.3} fill="#E0E0E0" stroke="#7D7D7D" strokeWidth={0.6} rx={1.7} />
    <rect width={11.4} height={3.4} x={88.3} y={40.3} fill="#B5B5B5" stroke="#7D7D7D" strokeWidth={0.6} rx={1.7} />
    <rect width={11.4} height={3.4} x={88.3} y={37.3} fill="#F0F0F0" stroke="#7D7D7D" strokeWidth={0.6} rx={1.7} />
    <rect width={11.4} height={3.4} x={88.3} y={34.3} fill="#E8E8E8" stroke="#7D7D7D" strokeWidth={0.6} rx={1.7} />
    <path
      fill="#7D7D7D"
      d="M92 36.3a.3.3 0 1 0 0-.6v.6Zm-3 0h3v-.6h-3v.6ZM92 39.3a.3.3 0 1 0 0-.6v.6Zm-3 0h3v-.6h-3v.6ZM92 42.3a.3.3 0 1 0 0-.6v.6Zm-3 0h3v-.6h-3v.6ZM92 45.3a.3.3 0 1 0 0-.6v.6Zm-3 0h3v-.6h-3v.6Z"
    />
    <path stroke="#959595" strokeLinecap="round" d="M22.436 2.976H107" />
    <path
      fill="#C3C3C3"
      stroke="#7E7E7E"
      strokeWidth={0.6}
      d="m67.732 4-1.156.263-.911-2.224 1.927-.438.14 2.4ZM80.514 3.594l1.156.263.911-2.225-1.927-.438-.14 2.4Z"
    />
    <path
      fill="#959595"
      d="M79.7 10.16 75.288 10c-.173 0-.31.16-.285.378l.743 6.404c.025.218.162.276.31.16l.595-.494a.895.895 0 0 1 .595-.204c.235.015 2.045.16 2.045.16.186.015.334-.145.36-.363l.346-5.475c.025-.218-.111-.392-.297-.406Zm-.087.61-.273 5.068c0 .087-.062.145-.136.116l-1.4-.349a.432.432 0 0 1-.36-.406l-.36-3.79c-.011-.088.05-.175.112-.19l2.28-.566c.087-.014.137.03.137.117ZM98.7 10.16 94.288 10c-.173 0-.31.16-.285.378l.743 6.404c.025.218.162.276.31.16l.595-.494a.895.895 0 0 1 .595-.204c.235.015 2.045.16 2.045.16.186.015.334-.145.36-.363l.346-5.475c.025-.218-.111-.392-.297-.406Zm-.087.61-.273 5.068c0 .087-.062.145-.136.116l-1.4-.349a.432.432 0 0 1-.36-.406l-.36-3.79c-.011-.088.05-.175.112-.19l2.28-.566c.087-.014.137.03.137.117Z"
    />
    <path
      fill="#C3C3C3"
      stroke="#7E7E7E"
      strokeWidth={0.6}
      d="m85.91 3.806-1.157.263-.91-2.225 1.926-.437.14 2.4ZM98.692 3.4l1.156.262.911-2.224L98.832 1l-.14 2.4Z"
    />
    <mask id="a" fill="#fff">
      <path d="M56.097 39.131a.66.66 0 0 0-.175-.316.86.86 0 0 0-.336-.207 1.131 1.131 0 0 0-.43-.058c-.15.008-.3.044-.437.104s-.259.144-.356.245a.843.843 0 0 0-.202.337.655.655 0 0 0 .178.67l.783-.554.975-.22Z" />
    </mask>
    <path
      fill="#EFEFEF"
      stroke="#959595"
      strokeWidth={2}
      d="M56.097 39.131a.66.66 0 0 0-.175-.316.86.86 0 0 0-.336-.207 1.131 1.131 0 0 0-.43-.058c-.15.008-.3.044-.437.104s-.259.144-.356.245a.843.843 0 0 0-.202.337.655.655 0 0 0 .178.67l.783-.554.975-.22Z"
      mask="url(#a)"
    />
  </svg>
);

export default LaundryPlaceholder;
